import GIF from 'gif.js.optimized'
import { gifProps, greenScreen } from '.'
import { MediaSprite } from '../../../types'
import { renderGif } from './render'

export async function getGifFromSprite(sprite: MediaSprite, isSticker: boolean = false): Promise<File> {
    const { columns, duration, frameHeight, frameIndexes, frameWidth, numFrames } = sprite
    const canvas = document.createElement('canvas')
    const context = canvas.getContext('2d')
    const frameDelay = Math.round((duration / numFrames) * 1000)

    const gif = new GIF({
        ...gifProps,
        transparent: isSticker ? '0x00ff00' : undefined,
        height: frameHeight,
        width: frameWidth,
    })

    for (let i = 0; i < frameIndexes.length; i++) {
        const delay = frameDelay || 100
        const index = frameIndexes[i]
        const x = (index % columns) * frameWidth
        const y = Math.floor(index / columns) * frameHeight

        canvas.width = frameWidth
        canvas.height = frameHeight
        context?.drawImage(sprite.canvas, x, y, frameWidth, frameHeight, 0, 0, canvas.width, canvas.height)

        if (isSticker) {
            greenScreen(canvas)
        }

        gif.addFrame(canvas, { copy: true, delay })
    }

    return renderGif(gif)
}
